<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>

        </div>

       <div class="content" v-else>

               <h1 v-if="type === 'add'">
                    Vytváření článku
               </h1>
               <h1 v-else>
                    Detail článku
               </h1>

         <div v-if="type !== 'add'">
           <v-btn
             color="secondary"
             :href="frontendUrl + '/blog/' + data.slug"
             target="_blank"
           >
             Zobrazit na webu
           </v-btn>
         </div>

         <v-layout>
               <table class="info-table">

                   <tr>
                       <td class="info-table__title">
                           Náhledový obrázek:
                       </td>
                       <td class="info-table__value info-table__value--blog-image">
                           <div v-if="!imageUploaded">
                               <div class="image image--loader">
                                   <div class="loader">
                                       <div class="loader__item">
                                       </div>
                                       <div class="loader__text">Nahrávání</div>
                                   </div>
                               </div>
                           </div>
                           <div v-else>
                               <div class="image image--data" v-if="data.image" :style="'background-image:url('+data.image+')'">
                               </div>
                               <div class="image image--empty" v-else>
                               </div>
                           </div>



                           <div class="image-controls"  v-if="imageUploaded ">
                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="!data.image"
                                       color="primary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat
                               </v-btn>

                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="data.image"
                                       color="secondary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat jiný
                               </v-btn>
                               <v-btn
                                       @click="removeCoverImage()"
                                       v-if="data.image"
                                       color="error"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Smazat
                               </v-btn>
                           </div>
                       </td>
                   </tr>
	               <tr >
		               <td class="info-table__title">
			               Alt:
		               </td>
		               <td class="info-table__value">
			               <v-text-field

				                class="input--larger"
				                outlined
				                v-model="data.image_alt"
				                @input="errors.image_alt = ''"
				                :error-messages="makeError(errors.image_alt)"
			               >
			               </v-text-field>
		               </td>
	               </tr>
                   <tr v-if="type !== 'add'">
                       <td class="info-table__title">
                           ID:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   disabled
                                   class="input--small"
                                   outlined
                                   v-model="data.id"
                                   @input="errors.id = ''"
                                   :error-messages="makeError(errors.id)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr >
                       <td class="info-table__title">
                           Název: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--larger"
                                   outlined
                                   v-model="data.name"
                                   @input="errors.name = ''"
                                   :error-messages="makeError(errors.name)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Slug: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--larger"
                                   outlined
                                   v-model="data.slug"
                                   @input="errors.slug = ''"
                                   :error-messages="makeError(errors.slug)"
                           >
                           </v-text-field>
                       </td>
                   </tr>

                   <tr >
                       <td class="info-table__title">
                           Autor: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-select
                                   :items="articleAuthors"
                                   item-value="id"
                                   item-text="name"
                                   class="input--small"
                                   outlined
                                   v-model="data.author_id"
                                   @input="errors.author_id = ''"
                                   :error-messages="makeError(errors.author_id)"
                           >
                           </v-select>
                       </td>
                   </tr>

                   <tr>
                       <td class="info-table__title">
                           Úvodní text: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-textarea
                                   class="input--larger"
                                   outlined
                                   v-model="data.text_short"
                                   @input="errors.text_short = ''"
                                   :error-messages="makeError(errors.text_short)"
                           >
                           </v-textarea>
                       </td>
                   </tr>
                   <!-- Obsah článku se od migrace na TipTap edituje na novém webu (viz odkaz "Upravit obsah na webu" výše), ne tady. -->
                   <!-- <tr>
                       <td class="info-table__title">
                           Text:
                       </td>
                       <td class="info-table__value">
                           <tiptap-vuetify
                                   class="wysiwyg wysiwyg--from-book"
                                   v-bind:class="{'wysiwyg--error':errors.text}"
                                   @input="errors.text = ''"
                                   v-model="data.text"
                                   :extensions="extensions"
                           />
                       </td>
                   </tr> -->

                 <tr>

                   <td class="info-table__title">
                     Audioknihy:
                   </td>
                   <td class="info-table__value">

                     <v-autocomplete
                         v-model="data.audiobooks"
                         :items="audiobooks"
                         :menu-props="{ maxHeight: '400' }"
                         multiple
                         :error-messages="makeError(errors.audiobooks)"
                         item-value="id"
                         @select="errors.audiobooks = ''"
                         item-text="name"
                         outlined
                         class="input--larger input--multiselect"
                         persistent-hint
                     ></v-autocomplete>
                   </td>
                 </tr>

                 <tr >
                   <td class="info-table__title">
                     Publikováno datum:
                   </td>
                   <td class="info-table__value info-table__value--date">

                     <v-text-field
                         class="input--small"
                         outlined
                         disabled
                         v-model="publishedAt"
                     >
                     </v-text-field>

                     <v-btn
                         color="secondary"
                         type="submit"
                         class="button--table"
                         @click="openDialogPublishedAt()"
                     >
                       Změnit
                     </v-btn>
                     <v-btn
                         color="error"
                         type="submit"
                         class="button--table"
                         @click="data.published_at = null"
                     >
                       Zrušit
                     </v-btn>

                   </td>
                 </tr>

<!--                   <tr>
                       <td class="info-table__title">
                           Publikováno datum:<br>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input&#45;&#45;small"
                                   outlined
                                   v-model="data.published_at"
                                   @input="errors.published_at = ''"
                                   :error-messages="makeError(errors.published_at)"
                           >
                           </v-text-field>
                       </td>
                   </tr>-->

                   <tr>
                       <td class="info-table__title">
                           Publikováno:
                       </td>
                       <td class="info-table__value">
                           <v-checkbox
                                   class="input--smaller"
                                   outlined
                                   v-model="data.published"
                                   @input="errors.published = ''"
                                   :error-messages="makeError(errors.published)"
                           >
                           </v-checkbox>
                       </td>
                   </tr>


               </table>

           </v-layout>

           <h2>SEO</h2>
           <v-layout>

               <table class="info-table">

                   <tr>
                       <td class="info-table__title">
                           Titulek:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.seo_title = ''"
                                   v-model="data.seo_title"
                                   :error-messages="makeError(errors.seo_title)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Popis:
                       </td>
                       <td class="info-table__value">
                           <v-textarea
                                   class="input--larger"
                                   outlined
                                   @input="errors.seo_meta = ''"
                                   v-model="data.seo_meta"
                                   :error-messages="makeError(errors.seo_meta)"
                           >
                           </v-textarea>
                       </td>
                   </tr>
                 <!--  <tr>
                       <td class="info-table__title">
                           Klíčová slova:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input&#45;&#45;larger"
                                   outlined
                                   @input="errors.seo_keywords = ''"
                                   v-model="data.seo_keywords"
                                   :error-messages="makeError(errors.seo_keywords)"
                           >
                           </v-text-field>
                       </td>
                   </tr>-->
               </table>
           </v-layout>

           <v-layout>
               <div class="controls-table">
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="addArticle()"
                           v-if="type === 'add'
                    ">
                       Vytvořit
                   </v-btn>
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="editArticle()"
                           v-else
                    >
                       Uložit
                   </v-btn>
                   <v-btn
                           color="error"
                           class="button--control"
                           @click="openDialogDelete()"
                           v-if="type !== 'add'"
                   >
                       Smazat
                   </v-btn>
               </div>
           </v-layout>

           <v-dialog v-model="dialogDelete" persistent>
               <v-card>
                   <v-card-title class="headline">Smazání článku</v-card-title>
                   <v-card-text>
                       Opravdu si přejete smazat článek <strong>{{data.name}}</strong>?
                   </v-card-text>
                   <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn
                               color="empty"
                               class="button--dialog"
                               @click="closeDialogDelete()"
                       >
                           zrušit
                       </v-btn>
                       <v-btn
                               color="error"
                               class="button--dialog"
                               @click="deleteArticle()"
                       >
                           smazat
                       </v-btn>
                       <v-spacer></v-spacer>
                   </v-card-actions>
               </v-card>
           </v-dialog>


         <v-dialog v-model="dialogPublishedAt" persistent>
           <v-card>
             <v-card-title class="headline">Publikováno datum</v-card-title>
             <v-date-picker
                 locale="cs-cz"
                 v-model="data.published_at"
                 @click:date="closeDialogPublishedAt()"
             ></v-date-picker>
             <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn
                   color="empty"
                   class="button--dialog"
                   @click="closeDialogPublishedAt()"
               >
                 zrušit
               </v-btn>
               <v-spacer></v-spacer>
             </v-card-actions>
           </v-card>
         </v-dialog>

       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import moment from 'moment';
    import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History,Image } from 'tiptap-vuetify'
    export default {
        name: 'VouchersDetail',
        components: {
            TiptapVuetify
        },

        data() {
            return {
              audiobooks: [],
              articleAuthors: [],
                imageUploaded: true,
                dialogDelete:false,
                type: 'add',
              dialogPublishedAt: false,
                loaded: false,
                loadedList: false,
                data: {},
                errors: {},
                frontendUrl: process.env.VUE_APP_FRONTEND_URL,
                extensions: [
                    History,
                    Link,
                    Underline,
                    Strike,
                    Italic,
                    ListItem,
                    BulletList,
                    OrderedList,
                    [Heading, {
                        options: {
                            levels: [2, 3]
                        }
                    }],
                    Bold,
                    Paragraph,
                    HardBreak,
                    Image
                ],
            }
        },

        created() {

          this.fetchAudiobooks();
          this.fetchArticleAuthors();
            this.fetchData();

            const vm = this;
            this.$root.$on('upload-blog-image', () => {
                vm.imageUploaded = false;
                vm.$forceUpdate();
            });
            this.$root.$on('uploaded-blog-image', (response) => {
                vm.data.image = response.url;
                vm.data.image_id = response.id;
                vm.imageUploaded = true;
                vm.$forceUpdate();
            });



        },
        computed: {
            ...mapState(['profile']),
          publishedAt(){
            if(this.data.published_at){
              return moment(this.data.published_at).format('DD.MM.YYYY');
            }else{
              return null;
            }
          },

        },
        mounted(){
        },
        methods: {
          fetchArticleAuthors(){
            this.$axios.get('/admin/article-authors').then((response) => {
              this.articleAuthors = response.data.authors;
            });
          },
          fetchAudiobooks(){
            this.$axios.get('/admin/audiobooks', {params: { pagination: 0, sortBy: 'name', order: 'ASC'}}).then((response) => {
              let audiobooks = response.data.audiobooks;

              this.audiobooks = audiobooks.map(it => {
                let type = ' (Audiokniha)'
                if(it.is_ebook) type = ' (E-kniha)'
                if(it.is_book) type = ' (Kniha)'
                it.name += type;
                return it;
              });
              this.loaded = true;
            }).catch((e) => {
              this.loaded = true;
            });
          },
          openDialogPublishedAt(){
            this.dialogPublishedAt = true;
          },
          closeDialogPublishedAt(){
            this.dialogPublishedAt = false;
          },
            makeError(item){
                if(item === 'required'){
                    return 'Toto pole je povinné';
                }else if(item === 'already_used'){
                    return 'Je již používaný';
                }else if(item === 'not_valid'){
                    return 'Neplatný formát';
                }else if(item === 'max_price'){
                    return 'Překročena cena knihy';
                }else if(item === 'not_in_range'){
                    return 'Není v rozmezí 1 - 100';
                }else if(item === 'code_exists'){
                    return 'Kód již existuje';
                }else if(item){
                    return 'Neznámá chyba';
                }else{
                    return '';
                }

            },
            selectCoverImage(){
                this.$root.$emit('select-blog-image');
            },
            removeCoverImage(){
                this.data.image_id = null;
                this.data.image = null;
                this.$forceUpdate();
            },
            openDialogDelete(){
                this.dialogDelete = true;
            },
            closeDialogDelete(){
                this.dialogDelete = false;
            },
            addArticle(){
                this.loaded = false;
                const request = this.data;
                this.$axios.post('/admin/articles/add', request).then((response) => {
                    this.$router.push({name: 'Blog'});
                }).catch((e) => {
                    if(e.response.data.error_inputs){
                        this.errors = e.response.data.error_inputs
                    }
                    this.loaded = true;
                });
            },
            editArticle(){
                this.loaded = false;
                const request = this.data;
                this.$axios.put('/admin/articles/'+this.$route.params.id+'/edit', request).then((response) => {
                    this.$router.push({name: 'Blog'});
                }).catch((e) => {
                    this.errors = e.response.data.error_inputs;
                    this.loaded = true;
                });
            },
            deleteArticle(){
                this.loaded = false;
                const request = this.data;
                this.$axios.delete('/admin/articles/'+this.$route.params.id+'/delete', request).then((response) => {
                    this.$router.push({name: 'Blog'});
                }).catch((e) => {
                    this.loaded = true;
                });
            },

            fetchData(){
                if(this.$route.params.id === 'add'){
                    this.type = 'add';
                    this.data = {};
                    this.loaded = true;

                }else{
                    this.type = 'detail';
                    this.$axios.get('/admin/articles/' + this.$route.params.id).then((response) => {
                        this.type = 'detail';
                        this.data = response.data.article;
                        this.loaded = true;
                    }).catch((e) => {
                        this.$router.push({name: 'Blog'});
                        this.loaded = true;
                    });
                }
            },


        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
